import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from 'ngx-flexible-layout';
// import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { BrowserModule } from '@angular/platform-browser';
import {
  AbcCoreAuthenticationModule,
  AuthenticationGuard,
  WebApiEditorGuard,
} from '@barthauer/abc/core/authentication';
import { UsersModule } from '@barthauer/abc/management/users';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { DxButtonModule, DxListModule, DxTileViewModule } from 'devextreme-angular';
import { LoginComponent } from './login/login.component';
import { ProfileSelectionComponent } from './profile-selection/profile-selection.component';
import { WebApiEditorComponent } from './webapi-editor/webapi-editor.component';
import { SetupInfoModule } from '@barthauer/abc/core/setup-info';

@NgModule({
  imports: [
    CommonModule,
    AbcCoreAuthenticationModule,
    MatMenuModule,
    DxTileViewModule,
    DxButtonModule,
    DxListModule,
    // BrowserModule,
    FlexLayoutModule,
    MatIconModule,
    MatListModule,
    FormsModule,
    ReactiveFormsModule,
    AbcUiComponentsModule,
    UsersModule,
    SetupInfoModule
  ],
  declarations: [LoginComponent, ProfileSelectionComponent, WebApiEditorComponent],
  exports: [LoginComponent, ProfileSelectionComponent, WebApiEditorComponent],
  providers: [AuthenticationGuard, WebApiEditorGuard],
})
export class BasysCoreAuthenticationModule {}
